import { render, staticRenderFns } from "./GalleryWindowView.vue?vue&type=template&id=08dcca28&scoped=true&"
import script from "./GalleryWindowView.vue?vue&type=script&lang=js&"
export * from "./GalleryWindowView.vue?vue&type=script&lang=js&"
import style0 from "./GalleryWindowView.vue?vue&type=style&index=0&id=08dcca28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dcca28",
  null
  
)

export default component.exports